import React, { useContext } from "react";
import DynamicHtml from "../CommonComponent/DynamicHtml";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";

const PrescriberNoteNoDetailsDisplay = ({isSectionField}) => {
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { benefitType } = useContext(SearchContext);

  const benefitTypeId = benefitType == "Pharmacy" ? 2 : 1;
  const prescriberNoteLogic = appliedConfiguration.coverageFinderPrescriberNoteLogics.filter(
    (obj) => obj.benefitTypeId === benefitTypeId
  )[0];

  if (prescriberNoteLogic?.emptySectionOrFieldValue?.toLowerCase() == "leave section blank") {
    return "";
  } else if (prescriberNoteLogic?.emptySectionOrFieldValue?.toLowerCase() == "dash-") {
    return <span className="norstella-cf-sectionFieldDash" part="cfSectionFieldDash">-</span>;
  } else if (prescriberNoteLogic?.emptySectionOrFieldValue?.toLowerCase() == "custom value") {
    return (
      <div className="norstella-cf-prescriberCustomNoteDialog" part="cfDivPrescriberCustomNoteDialog">
        {prescriberNoteLogic?.emptySectionOrFieldValue?.toLowerCase() == "custom value" && (
          <DynamicHtml
            input={prescriberNoteLogic?.customValue}
            resultname=""
            className="norstella-cf-prescriberNoteCustomValue"
            part="cfPrescriberNoteCustomValue"
          />
        )}
        {prescriberNoteLogic?.emptySectionOrFieldValue?.toLowerCase() == "leave section blank" && ""}
      </div>
    );
  } else {
    return isSectionField ? "" : <span className="norstella-cf-sectionFieldNoDetails" part="cfSectionFieldNoDetails">There are no criteria details available.</span>;
  }
};

export default PrescriberNoteNoDetailsDisplay;
